import {IconProps} from "../../types/IconProps";

const ArrowUpRight = ({ width = 800, height = 800, color = '#000' }: IconProps) => {
    return (
        <svg width={`${width}px`} height={`${width}px`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <polyline data-name="Right" fill="none" id="Right-2" points="18.7 12.4 18.7 5.3 11.6 5.3" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <line fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" x1="5.3" x2="17.1" y1="18.7" y2="6.9"/>
        </svg>
    );
}

export default ArrowUpRight;